export default "__VITE_ASSET__6pEt8Jo5__"